<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <v-form v-if="Boolean(economicGroup)" ref="form" @submit.prevent="submit">
      <NewEconomicGroupForm
        :value="groupInfo"
        :balance-documents-model="balanceDocuments"
        :balance-error-messages="balanceFormErrors"
        :documents-model="otherDocuments"
        :advisor-error-messages="advisorErrorMessages"
        :atendentList="atendentList"
        :comercialList="comercialList"
        :contacts-error-messages="contactsErrorMessages"
        :productList="productList"
        :office-list="officeList"
        @more-advisories="onRequestedMoreAdvisories"
        @open-balance-modal="onToggleBalanceModal"
        @open-single-document-modal="onToggleSingleDocumentModal"
        @preview-document="onPreviewDocument"
        @remove-document="onRemoveDocument"
        @preview-file="onPreviewFile"
        @remove-file="onRemoveFile"
        @remove-others-documents="onRemoveOthersDocuments"
        @open-contact-modal="isContactModalOpen = true"
        @edit-contact="onEditContact"
        @search-users="onSearchUser"
      >
        <template v-slot:header>
          <v-row class="mb-md-2">
            <v-col cols="12" sm="4" md="6" xl="7">
              <h3 class="gray--text mb-4 mb-md-0" v-if="userAreaIsGarantia">GRUPO ECONÔMICO</h3>
            </v-col>
            <v-col cols="12" sm="4" md="3" class="pr-sm-2">
              <BaseButton
                outlined
                color="blue"
                class="mb-8 mb-md-0"
                width="100%"
                @click="goToListCompanies"
              >
                {{ textListCompaniesButton }}
              </BaseButton>
            </v-col>
            <v-col cols="12" sm="4" md="3" xl="2">
              <BaseButton
                outlined
                color="green"
                class="mb-8 mb-md-0"
                @click="goToListLimitCredit"
                width="100%"
              >
                {{ textCreditLimitButton }}
              </BaseButton>
            </v-col>
          </v-row>
          <div class="d-flex mb-4">
            <v-switch
              v-model="groupInfo.ativo"
              class="pa-0 ma-0"
              color="secondary"
              inset
              hide-details
              dense
            />
            <p class="darkBluishGray--text caption">Grupo Ativo</p>
          </div>
          <div class="d-flex mb-4">
            <v-switch
              v-model="groupInfo.exibir_comissao_cotacao"
              class="pa-0 ma-0"
              color="secondary"
              inset
              hide-details
              dense
            />
            <p class="darkBluishGray--text caption mb-0">
              Exibir Comissão na Cotação?
            </p>
          </div>
        </template>
      </NewEconomicGroupForm>
      <BaseFooter>
        <v-row>
          <v-spacer />
          <v-col class="pr-sm-5" cols="12" sm="3">
            <BaseButton
              class="error subtitle-2 font-weight-bold"
              width="100%"
              :to="{ name: 'economic_group' }"
              v-html="'CANCELAR'"
            />
          </v-col>
          <v-col cols="12" sm="3">
            <BaseButton
              type="submit"
              class="secondary text-uppercase subtitle-2 font-weight-bold"
              width="100%"
            >
              SALVAR
            </BaseButton>
          </v-col>
        </v-row>
      </BaseFooter>
    </v-form>
    <BalanceModal
      v-if="isBalanceModalOpen"
      v-model="isBalanceModalOpen"
      :form-model="selectBalanceDocumentModel"
      @selected-files="onSelectedBalanceDocuments"
      @preview-file="onPreviewFile"
      @remove-file="onRemoveFile"
      @submit="onCompletedBalanceDocumentSelection"
      @close="onToggleBalanceModal"
    />
    <SingleDocumentModal
      v-if="isDocumentModalOpen"
      v-model="isDocumentModalOpen"
      :title="documentModalTitle"
      :type-document="documentModalForKey"
      @submit="onCompletedDocumentSelection"
      @close="onToggleDocumentModal"
    />
    <NewContactModal
      v-model="isContactModalOpen"
      :item="contact"
      title="INCLUIR NOVO CONTATO"
      @submit="onAddContact"
      @close="isContactModalOpen = false"
    />
    <ModalCancelEconomicGroup
      @close="closeModalCancel"
      v-model="modalCancel"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </Main>
</template>

<script>
import _ from "lodash";
import { defineGuid, objectGuid } from "@/utils/guid";
import { normalizeCnpj } from "@/utils/documents.js";
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import EconomicGroupMixin from "../mixins/EconomicGroupMixin";
import NewEconomicGroupForm from "../components/NewEconomicGroupForm.vue";
import BalanceModal from "../components/BalanceModal.vue";
import SingleDocumentModal from "../components/SingleDocumentModal.vue";
import NewContactModal from "../components/NewContactModal.vue";
import ModalCancelEconomicGroup from "../../insurance_company/components/ModalCancelInsurance";
export default {
  beforeRouteLeave(to, from, next) {
    if (this.cancel || this.formIsPristine()) next();
    this.modalCancel = true;
    this.nextRoute = to;
  },
  name: "EconomicGroup",
  mixins: [LoadingRequest, EconomicGroupMixin],
  components: {
    NewEconomicGroupForm,
    BalanceModal,
    SingleDocumentModal,
    NewContactModal,
    ModalCancelEconomicGroup
  },
  data: () => ({
    isContactModalOpen: false,
    contact: {},
    groupInfo: null,
    balanceDocuments: { documents: [] },
    otherDocuments: {
      contrato_social: [],
      estatuto: [],
      ata: [],
      outros: []
    },
    documentModalForKey: null,
    advisorErrorMessages: [],
    atendentList: [],
    comercialList: [],
    contactsErrorMessages: [],
    productList: [],
    nextRoute: null,
    modalCancel: false,
    cloneForm: null,
    cloneBalanceDocuments: null,
    cloneOtherDocuments: null,
    officeList: [],
    isValidForm: false
  }),
  created() {
    this.fetchData(this.groupId);
    const payload = "";
    const payload_user_comercial =
      "?&estrutura_id=funcionario&posicao_id=comercial";
    const payload_user_atendent =
      "?&estrutura_id=funcionario&posicao_id=tecnico";
    let vm = this;
    this.withLoading(
      Promise.all([
        this.suggestOperationalGroups(payload).then(users => {
          vm.productList = users;
        }),
        this.suggestUsers(payload_user_comercial).then(users => {
          vm.comercialList = users;
        }),
        this.suggestUsers(payload_user_atendent).then(users => {
          vm.atendentList = users;
        })
      ])
    );
  },
  computed: {
    ...mapState("economic_group", ["economicGroup"]),
    ...mapState("me", ["myInfo", "userAreaIsGarantia"]),
    userArea() {
      return this.myInfo.area_usuario;
    },
    isDocumentsRequired() {
      return this.userArea.id == "garantia";
    },
    textListCompaniesButton() {
      return this.userAreaIsGarantia ? "VER LISTA DE TOMADORES" : "EMPRESAS DO GRUPO";
    },
    textCreditLimitButton() {
      return this.userAreaIsGarantia ? "LIMITE DE CRÉDITO" : "SEGURADORAS";
    },
    groupId() {
      return this.$route.params.groupId;
    },
    selectBalanceDocumentModel() {
      return this.balanceDocuments;
    },
    selectDocumentModel() {
      return this.otherDocuments;
    },
    breadcrumb() {
      const { nome } = this.economicGroup || { nome: "" };
      return [
        {
          text: `Grupo Econômico: ${nome}`,
          to: "economic_group list"
        }
      ];
    },
    formData() {
      const { cnpj, razao_social, ...group } = this.groupInfo;

      const representedByCompany = ({ representado_por_pj }) =>
        !representado_por_pj
          ? null
          : {
              cnpj,
              razao_social
            };

      return {
        ...group,
        ...representedByCompany(this.groupInfo),
        balancos: [],
        documentos: []
      };
    }
  },
  methods: {
    ...mapActions(["suggestUsers", "suggestOperationalGroups"]),
    ...mapActions("economic_group", [
      "findLegalPerson",
      "findEconomicGroup",
      "updateEconomicGroup",
      "requestOffices",
      "requestUploadLogo"
    ]),
    formIsPristine() {
      // Obrigado mask por facilitar minha vida ...
      return (
        _.isEqual(
          _.omit(this.cloneForm, "cnpj"),
          _.omit(this.groupInfo, "cnpj")
        ) &&
        _.isEqual(
          this.cloneBalanceDocuments,
          this.balanceDocuments.documents
        ) &&
        _.isEqual(this.cloneOtherDocuments, this.otherDocuments) &&
        (!this.groupInfo.cnpj ||
          normalizeCnpj(this.cloneForm.cnpj) ===
            normalizeCnpj(this.groupInfo.cnpj))
      );
    },
    closeModalCancel(value) {
      this.cancel = value;
      this.modalCancel = false;
      if (value) {
        this.$router.push({
          name: this.nextRoute.name,
          params: this.nextRoute.params
        });
      }
    },
    previousPage() {
      this.$router.push({ name: "economic_group list" });
    },
    onAddContact(item) {
      const guid = objectGuid(item);
      if (!guid) {
        this.groupInfo.contatos = this.groupInfo.contatos.concat([
          defineGuid(item)
        ]);
      }
      this.contact = {};
      this.isContactModalOpen = false;
    },
    onEditContact(item) {
      this.contact = this.groupInfo.contatos.find(
        contact => objectGuid(contact) === objectGuid(item)
      );
      this.isContactModalOpen = true;
    },
    onSearchUser(payload, list) {
      let vm = this;
      if (list == "productList") {
        this.withLoading(
          this.suggestOperationalGroups(payload).then(users => {
            vm[list] = users;
          })
        );
      } else {
        this.withLoading(
          this.suggestUsers(payload).then(users => {
            vm[list] = users;
          })
        );
      }
    },
    onRequestedMoreAdvisories() {
      this.groupInfo.assessores = this.groupInfo.assessores.concat([
        { nome: "" }
      ]);
    },
    goToListCompanies() {
      this.cancel = true;
      this.$router.push({
        name: "economic_group companies list",
        params: { groupId: this.economicGroup.id }
      });
    },
    goToListLimitCredit() {
      this.cancel = true;
      this.$router.push({ name: "economic_group credit_limit list" });
    },
    goToList() {
      this.$router.push({ name: "economic_group list" });
    },
    onCompletedBalanceDocumentSelection(docs) {
      this.onSelectedBalanceDocuments(docs);
      this.isBalanceModalOpen = false;
    },
    onCompletedDocumentSelection(doc) {
      this.onSelectedDocument(doc);
      this.documentModalForKey = null;
    },
    onRemoveOthersDocuments(item) {
      this.otherDocuments[item.tipo_documento.id] = this.otherDocuments[
        item.tipo_documento.id
      ].filter(document =>
        document.id
          ? document.id !== item.id
          : document.arquivo.nome !== item.arquivo.nome
      );
    },
    validate() {
      this.isValidForm = true;

      this.balanceFormErrors = [];
      if ( this.isDocumentsRequired && this.balanceDocuments.documents.length == 0 ) {
        this.balanceFormErrors = ["É preciso adicionar pelo menos um arquivo de balanço."];
        this.isValidForm = false;
      }

      this.contactsErrorMessages = [];
      if ( this.groupInfo.contatos.length == 0 ) {
          this.contactsErrorMessages = ["É preciso adicionar pelo menos um contato."];
          this.isValidForm = false;
      }

      return (
        this.$refs.form.validate() &&
        this.isValidForm
      );
    },
    async submit() {
      if (!this.validate()) {
        return;
      }

      if (this.formData.logo != null && this.formData.logo?.url == null) {
        await this.withLoading(
          this.requestUploadLogo(this.getUploadFilePayload(this.formData.logo))
        ).then((resp) => {
          this.formData.logo = resp;
        });
      }

      this.withLoading(
        this.submitDocuments(this.balanceDocuments, this.otherDocuments).then(
          ({ balancos, documentos}) => {
            let userArea = this.userArea;
            let payload = _.cloneDeep(this.formData);
            if (payload.cnpj) payload.cnpj = normalizeCnpj(payload.cnpj);
            this.updateEconomicGroup({
              groupId: this.groupId,
              info: {
                ...payload,
                documentos,
                balancos,
                userArea
              }
            })
              .then(economicGroup => {
                this.showAlertNotification({
                  message: `Grupo '${economicGroup.nome}' editado com sucesso.`,
                  type: "success"
                });
                this.cancel = true;
                this.$router.push({ name: "economic_group list" });
              })
              .catch(error => {
                this.showAlertNotification({
                  message: !error.response
                    ? "Aconteceu um erro ao tentar salvar a edição do grupo"
                    : error.response.data.details &&
                      error.response.data.details.length > 0
                    ? error.response.data.details.reduce(
                        (acc, { message }) => acc.concat(message),
                        ""
                      )
                    : error.response.data.error_description,
                  type: "error"
                });
              });
          }
        )
      );
    },
    makeLocalCopy(economicGroup) {
      this.groupInfo = _.cloneDeep(economicGroup);
      this.groupInfo.contatos = economicGroup.contatos.map(contact =>
        defineGuid(contact)
      );
      this.balanceDocuments.documents = economicGroup.balancos;
      economicGroup.documentos.forEach(document =>
        this.otherDocuments[document.tipo_documento.id].push(document)
      );
      this.cloneForm = _.cloneDeep(this.groupInfo);
      this.cloneBalanceDocuments = _.cloneDeep(this.balanceDocuments.documents);
      this.cloneOtherDocuments = _.cloneDeep(this.otherDocuments);
    },
    fetchData(groupId) {
      this.withLoading(this.findEconomicGroup(groupId)).then(
        this.makeLocalCopy
      );
      let vm = this;
      this.withLoading(
        this.requestOffices().then(list => {
          vm.officeList = list;
        })
      );
    }
  }
};
</script>

<style lang="sass">
.truncate
  max-width: 300px
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis

.dialog__close-btn
  font-size: 18px !important
</style>
